module.exports = __webpack_public_path__ + "static/media/Chat.ce47c968.svg";